import React from 'react';
import styled from "styled-components";
import userpic from "../assets/user.png";

function UserAvatar(props) {
    return (
        <ProfileImage src={userpic} alt="User Image"/>
    );
}

const ProfileImage = styled.img`
  border-radius: 50%;
  height: 84px;
  border: 2px solid white;
  margin-bottom: 30%;
`

export default UserAvatar;